/**
 * 模块简介:根级别的 store
 * 作用:所有的store子模块的顶级父类,是Vuex对外export的总出口
 */
// 1.引入vuex，别忘了Vue.use(Vuex)
import Vue from 'vue'
import Vuex from 'vuex'
// 2.引入各个子模块
import getters from './getters'
import app from './modules/app'
import user from './modules/user'
import demo from './modules/demo'
import crm from './modules/crm'
import order from './modules/order'
import role from './modules/role'
import qc from './modules/qc'
import skill from './modules/skill'
import system from './modules/system'
import emojis from './modules/emojis'

Vue.use(Vuex)

// 3.创建store实例的同时export出去
export default new Vuex.Store({
  getters,
  modules: {
    demo, // 等同于demo:demo的简写
    user,
    crm,
    order,
    app,
    role,
    qc,
    skill,
    system,
    emojis
  }
})
